import React from "react";
import { ListItem, ListItemIcon, ListItemText } from "e100-react-components";
import { Icon } from "components";
import { SortTypeMyFleet } from "features/myFleet/types";
import { useStyles } from "./styles";
import { ObuStatusIcon } from "../ObuStatusIcon/ObuStatusIcon";
import { useSortOrder } from "features/myFleet/store";
import { useMyFleetOperations } from "features/myFleet/hooks";

interface SortItemProps {
  label: string;
  sortType: SortTypeMyFleet;
}

export const SortItem = ({ label, sortType }: SortItemProps) => {
  const classes = useStyles();
  const selectedSortType = useSortOrder();
  const { setSortOrder } = useMyFleetOperations();
  const isActive = selectedSortType === sortType;

  const onClick = () => {
    setSortOrder(sortType);
  };

  return (
    <ListItem button onClick={onClick}>
      <ListItemText
        primary={
          <div className={classes.iconContainer}>
            {label}
            {(sortType === "byLocationStatusAsc" ||
              sortType === "byLocationStatusDesc") && (
              <ObuStatusIcon sortType={sortType} />
            )}
          </div>
        }
        primaryTypographyProps={{
          variant: "subtitle2",
          color: "textPrimary",
        }}
      />

      {isActive && (
        <ListItemIcon
          classes={{
            root: classes.iconList,
          }}
        >
          <Icon kind="done" />
        </ListItemIcon>
      )}
    </ListItem>
  );
};
